import { Outlet } from 'react-router-dom';
import { Loader } from '@sib/ui';
import { useSpendbrainRoutesAccess } from '@spendbrain/hooks';

/**
 * Renders in place of the routed <Outlet /> inside the nav shell. The
 * permission guard (useSpendbrainRoutesAccess) fails open while organization
 * data is still loading, so ProtectedRoute renders the matched page
 * optimistically before permissions are known — without this gate, a
 * permission-denied page would flash its own content/loading state for a
 * moment before the guard catches up (once org data resolves) and redirects.
 * This keeps the nav shell mounted (no full-page flash) and blocks only the
 * content area, specifically for the duration of that organization fetch.
 */
export const OrganizationDataGate = () => {
  const { isOrganizationDataLoading } = useSpendbrainRoutesAccess();

  if (isOrganizationDataLoading) {
    return (
      <div className="flex size-full items-center justify-center p-10">
        <Loader className="text-primary size-24 opacity-50" />
      </div>
    );
  }

  return <Outlet />;
};
